import GuideBoard from 'components/GuideBoard/GuideBoard';
import LoadingImage from 'components/LoadingImage';
import MenuTop from 'components/Menu';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setGuideBoardVisible, setPanoData, setTourData } from 'store/actions';
import { loadTourJson } from 'utils/apiHelper';

const tourId = process.env.REACT_APP_TOUR_ID;

export const Layout = ({ children, className = '' }) => {
  const dispatch = useDispatch();
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const location = useLocation();

  

  useEffect(() => {
    const handleGetTour = async () => {
      const { json, tour } = await loadTourJson(tourId);

      dispatch(setPanoData(json));
      dispatch(setTourData(tour));

      setIsApiLoaded(true);
    };

    handleGetTour();
  }, [dispatch]);

    // Compute GuideBoard visibility based on current URL path
    useEffect(() => {
      const pathname = location?.pathname || window.location.pathname || '';
      const path = pathname.toLowerCase();

      const shouldShow =
        path.includes('/mat-bang-tang') ||
        path.includes('/tong-quan') ||
        path.includes('/can-ho-mau');

      const shouldHide =
        path.includes('/vi-tri') || path.includes('/tien-ich');

      if (shouldShow) dispatch(setGuideBoardVisible(true));
      else if (shouldHide) dispatch(setGuideBoardVisible(false));
    }, [location, dispatch]);

  return (
    <>
      <div
        style={{ display: 'flex', flexDirection: 'column', height: '100dvh' }}
        className={`layout ${className}`}
      >
        <LoadingImage
          isApiLoaded={isApiLoaded}
          onStarted={() => {
            // after 3s from loading start, show guide board behind loading
            const pathname = location?.pathname || window.location.pathname || '';
            const path = pathname.toLowerCase();
            const shouldShow =
              path.includes('/mat-bang-tang') ||
              path.includes('/tong-quan') ||
              path.includes('/can-ho-mau');
            const shouldHide =
              path.includes('/vi-tri') || path.includes('/tien-ich');
            if (shouldShow) dispatch(setGuideBoardVisible(true));
            else if (shouldHide) dispatch(setGuideBoardVisible(false));
          }}
        />
        {isApiLoaded && (
          <>
            <MenuTop />
            <div
              className="layout-content"
              style={{
                display: 'flex',
                flex: 1,
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              {children}
            </div>
          </>
        )}
      </div>

      <GuideBoard />
    </>
  );
};
